<template>
  <div class="fixed top-0 left-0 w-screen h-full bg-white">
    <page class="h-full" :head-text="headText">
      <template #rightBtn>
        <img
          src="../../../assets/common/close-icon.svg"
          alt="menu"
          @click="$emit('clear-active-page')"
        />
      </template>
      <template #content>
        <template v-if="!isPasswordPage">
          <phone
            class="mb-3"
            v-model="localNumber"
            :country-code="countryCode"
            @edit-code="openCountryCode"
          />
          <div class="message text-xs">{{ $t('login.sent_verification_code') }}</div>
          <c-button
            class="mt-16"
            :confirmed-status="confirmedStatus"
            @click="confirmedPhoneNumber()"
          >
            <span>{{ $t('login.send') }}</span>
          </c-button>
          <error-message v-if="errorMsg" :message="errorMsg" />
        </template>
        <template v-else>
          <div class="purple-round-input input-wrapper relative mt-12">
            <input
              class="w-full h-12 pl-6 outline-none"
              :type="inputType"
              v-model="password"
              :placeholder="$t('login.password')"
              autofocus
              @keyup.enter="setPassword"
            />
            <img
              v-if="isHide"
              class="eye-icon absolute"
              src="../../../assets/common/eye.svg"
              @click="isHide = !isHide"
            />
            <img
              v-else
              class="eye-icon absolute"
              src="../../../assets/common/black-eye.svg"
              @click="isHide = !isHide"
            />
          </div>
          <c-button class="mt-16" :confirmed-status="confirmedStatus" @click="setPassword">
            <span>{{ $t('login.sign_up') }}</span>
          </c-button>
        </template>
      </template>
    </page>
    <country-code
      v-if="showCountryCode"
      :country-code.sync="countryCode"
      @set-close-status="closeCountryCode"
      @use-email="$emit('use-email')"
    />
    <confirm-token
      v-if="showConfirmToken"
      :phone-number="phoneNumber"
      :show-confirm-token.sync="showConfirmToken"
      :error="wrongToken"
      @token="confirmToken"
      @set-password-page="setPasswordPage"
      @confirmed-phone-number="confirmedPhoneNumber"
      @clear-active-page="$emit('clear-active-page')"
    />
  </div>
</template>

<script>
import ApiActions from '@/modules/api-actions';
import handlePhoneInput from '@/mixins/handle-phone-input';
import Phone from '@/components/common/Fields/Phone.vue';
import Page from '@/components/common/Page.vue';
import CButton from '@/components/common/CButton.vue';
import CountryCode from './SupportedCountryCode.vue';
import ConfirmToken from './ConfirmToken.vue';
import ErrorMessage from '../common/ErrorMessage.vue';

const PHONE_PROVIDER = 0;

export default {
  mixins: [handlePhoneInput],
  components: {
    Page,
    CButton,
    CountryCode,
    ConfirmToken,
    Phone,
    ErrorMessage,
  },
  data() {
    return {
      password: '',
      showConfirmToken: false,
      isPasswordPage: false,
      token: '',
      isHide: true,
      wrongToken: false,
      errorMsg : '',
    };
  },
  mounted() {
    this.openCountryCode();
  },
  computed: {
    confirmedStatus() {
      if (this.isPasswordPage) {
        return this.password.length > 3;
      }
      const regExp = /^[0-9]+$/;
      const phoneNumber = this.localNumber;
      return !(!regExp.test(phoneNumber) || phoneNumber.length < 5);
    },
    headText() {
      if (!this.isPasswordPage) {
        return this.$t('login.sign_up_phone');
      }
      return this.$t('login.set_up_new_pwd');
    },
    inputType() {
      return this.isHide ? 'password' : 'text';
    },
  },
  methods: {
    async checkPhoneAvailable() {
      try {
        return ApiActions.user.checkPhoneAvailable({
          username: this.phoneNumber,
          provider: PHONE_PROVIDER,
        });
      } catch (e) {
        console.log(e.message);
        return false;
      }
    },
    async confirmedPhoneNumber() {
      if (!this.confirmedStatus) return;

      this.$events.startLoading();

      const isAvailable = await this.checkPhoneAvailable();
      if (!isAvailable) {
        this.$events.stopLoading();
        this.$toasted.global.alert(this.$t('login.try_to_login'));
        return;
      }

      try {
        await ApiActions.user.requestConfirmationToken({
          mobile_phone: this.phoneNumber,
          provider: PHONE_PROVIDER,
          locale: this.countryCode.code,
        });
        this.showConfirmToken = true;
      } catch (e) {
        const { response } = e;
        if (response) {
          const { data } = response;
          this.errorMsg = data.error.msg;
        }
        console.log(e.message);
      }
      this.$events.stopLoading();
    },
    async confirmToken(token) {
      if (!token) return;

      this.$events.startLoading();

      try {
        await ApiActions.user.confirmToken({
          confirm_token: token,
          provider: PHONE_PROVIDER,
          mobile_phone: this.phoneNumber,
        });
        this.token = token;
        this.setPasswordPage();
      } catch (e) {
        console.log(e.message);
        this.wrongToken = true;
      }
      this.$events.stopLoading();
    },
    async setPassword() {
      if (!this.confirmedStatus) return;

      this.$events.startLoading();

      try {
        const username = await ApiActions.user.registerPhone({
          mobile_phone: this.phoneNumber,
          password: this.password,
          confirm_token: this.token,
          provider: PHONE_PROVIDER,
        });
        await ApiActions.user.login({
          username,
          password: this.password,
          provider: PHONE_PROVIDER,
        });
        this.$emit('done');
      } catch (e) {
        console.log(e.message);
        this.$events.stopLoading();
      }
    },
    setPasswordPage() {
      this.showConfirmToken = false;
      this.isPasswordPage = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  width: 309px;
}

.message {
  color: #6a6a6a;
}

.eye-icon {
  top: 50%;
  right: 21px;
  transform: translateY(-50%);
}
</style>
